import View from '../../view.js';

class PrimaryCustomerRetrieval extends View {
  get dom() {
    return {
      CUSTOMER_DROPDOWN: '#assigned-customers',
      PRIMARY_CUSTOMER_DROPDOWN: '#user_primary_customer_id',
      PRIMARY_CUSTOMER_DROPDOWN_CONTROL: '.primary_customer .control',
    };
  }

  get events() {
    var events = {};

    events['change ' + this.dom.CUSTOMER_DROPDOWN] = '_reloadCustomers';
    events['change ' + this.dom.PRIMARY_CUSTOMER_DROPDOWN] = '_showAuthMethod';
    return events;
  }

  initialize() {
    this._showAuthMethod();
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  _reloadCustomers() {
    var self = this;

    $.ajax({
      url: '/' + currentCustomer + '/users/available_primary_customers',
      data: {
        assigned_customers: $(self.dom.CUSTOMER_DROPDOWN).val() || [], // eslint-disable-line camelcase
      },
    })
      .done(function (data) {
        self._populateDropdown(
          $(self.dom.PRIMARY_CUSTOMER_DROPDOWN),
          data.customers,
        );
        // check if the primary customer field already have a value
        if ($('#user_primary_customer_id option:selected').length < 1) {
          if ($('#assigned-customers option:selected').val() < 0) {
            // check if the first assigned customer id is -1, which if the all sites id
            $('#user_primary_customer_id option')
              .filter(function () {
                return $(this).text() === 'REL';
              })
              .prop('selected', true)
              .trigger('change');
          } else {
            $('#user_primary_customer_id option:first')
              .prop('selected', true)
              .trigger('change');
          }
        }
      })
      .fail(function () {
        alert(
          'An error occurred while fetching data. Please try selecting a Store again.',
        );
        self._populateDropdown($(self.dom.PRIMARY_CUSTOMER_DROPDOWN), '');
      });
  }

  _populateDropdown(target, data) {
    var previousValues = target.val();

    target = $(target);
    target.select2().html(data);
    target.select2().val(previousValues);
    target.select2({ selectOnBlur: false }).trigger('change');
  }

  _showAuthMethod() {
    if (!$(this.dom.PRIMARY_CUSTOMER_DROPDOWN)[0]) {
      return;
    }
    let control = $(this.dom.PRIMARY_CUSTOMER_DROPDOWN_CONTROL),
      options = $(this.dom.PRIMARY_CUSTOMER_DROPDOWN)[0].options;

    if (options) {
      let selectedOption = options[options.selectedIndex],
        data = selectedOption ? selectedOption.dataset : null;

      control.children().remove('i');

      if (data && data.auth) {
        let samlHost = data.saml ? '- ' + data.saml : '';

        control.append(
          `<i><br>Selected Authentication Method: ${data.auth.toUpperCase()} ${samlHost}</i>`,
        );
      }
    }
  }
}

module.exports = PrimaryCustomerRetrieval;
